import { Accordion } from 'react-bootstrap';

import '../../styles/user/main.scss';
import '../../styles/user/status-histories.scss';
import { orderStatusMappings } from '../../types/order';
import { formatDateTime } from '../../helpers/datetime';
import { useSelector } from 'react-redux';
import { language } from '../../language';

const StatusHistories = (props) => {
  const hrMobileLanguage = useSelector((state) => state.app.slsHrMobileLanguage);

  return (
    <div className='status-histories'>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <span style={{ fontSize: '14px' }}>
              {language?.statusHistories?.[hrMobileLanguage]}:
            </span>
          </Accordion.Header>
          <Accordion.Body>
            <ul className="timelines">
              {_.orderBy(props?.currentOrderHistory?.orderStatus?.orderHistories, ['createdAt'], ['desc'])?.map((v, i) => (
                <li key={i}>
                  <small className='status-name' style={{
                    color: orderStatusMappings?.find((osm) => osm.key == v?.orderStatusId)?.color,
                  }}>{orderStatusMappings?.find((osm) => osm.key == v?.orderStatusId)?.displayLabel?.[hrMobileLanguage] || ''}</small>
                  <div className="time">{formatDateTime({
                    dateTime: v?.createdAt,
                    convertToThai: hrMobileLanguage == 'th' ? true : false,
                  })}</div>
                  <div className="note">{v?.note}</div>
                </li>
              ))}
            </ul>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default StatusHistories;
